const EUCountries = [
	'AT', 'BE', 'BG', 'HR', 'CZ', 'CY', 'DK', 'EE', 'FI', 'FR',
	'DE', 'EL', 'IE', 'HU', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
	'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'GB', 'UK'
];

const ForbiddenCountries = [
	'YE', 'IR', 'TZ', 'SY', 'UG', 'ET', 'ZW', 'ZM', 'MW', 'MU', 'MZ', 'MG', 'TT', 'PH', 'JO',
	'PK', 'BT', 'NP', 'LK', 'KH', 'IQ', 'OM', 'GH', 'EH', 'TN', 'MA', 'AD', 'GT', 'EC', 'AO', 'GY', 'SR',
	'PY', 'UY', 'BZ', 'BO', 'PS', 'TH', 'KW', 'KE', 'VN', 'LB', 'NG', 'MY', 'ID', 'IN', 'BD', 'TW', 'MM'
];

const isEUCountry = country_code => EUCountries.includes(country_code);
const isForbiddenCountry = country_code => ForbiddenCountries.includes(country_code);

const toggleOrderDirection = direction => (direction === 'desc' || !direction) ? 'asc' : 'desc';

export {
	isEUCountry,
	isForbiddenCountry,
	toggleOrderDirection
};



// WEBPACK FOOTER //
// ./frontend/shared/js/helpers.js